import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "training-paper-modal"
};
const _hoisted_2 = {
  class: "toolbox"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_4 = {
  class: "pager"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { trainingPaperList } from '@/request';
export default {
  name: 'paper-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });
    const courseKeyword = ref('');
    const keyword = ref('');
    const tableData = ref([]);
    const loading = ref(false);
    const selectedPaperId = ref(null);
    const page = ref(1);
    const pageSize = ref(20);
    const total = ref(0);
    watch(() => props.modelValue, v => {
      if (v) {
        courseKeyword.value = '';
        keyword.value = '';
        page.value = 1;
        selectedPaperId.value = null;
        getList();
      }
    });

    function getList() {
      loading.value = true;
      trainingPaperList({
        courseKeyword: courseKeyword.value || undefined,
        keyword: keyword.value || undefined,
        page: page.value,
        pageSize: pageSize.value
      }).then(res => {
        if (!res.success) {
          ElMessage.error(res.msg || '获取试卷列表失败');
          tableData.value = [];
          total.value = 0;
          return;
        }

        ;
        tableData.value = res.data || [];
        total.value = Number(res.total || 0);
      }).finally(() => {
        loading.value = false;
      });
    }

    function onPageChange(value) {
      page.value = value;
      getList();
    }

    function submit() {
      const selected = tableData.value.find(item => item.paperId == selectedPaperId.value);
      if (!selected) return ElMessage.warning('请选择培训试卷');
      emit('success', selected);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "请选择培训试卷",
        width: "1000px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: courseKeyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => courseKeyword.value = $event),
          placeholder: "请输入课程名称",
          clearable: "",
          style: {
            "width": "240px",
            "margin-right": "10px"
          },
          onKeyup: _withKeys(getList, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => keyword.value = $event),
          placeholder: "请输入试卷名称",
          clearable: "",
          style: {
            "width": "240px",
            "margin-right": "10px"
          },
          onKeyup: _withKeys(getList, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: getList
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          "max-height": "480"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "选择",
            width: "55"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_radio, {
              name: "selectPaper",
              modelValue: selectedPaperId.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => selectedPaperId.value = $event),
              label: scope.row.paperId
            }, null, 8, ["modelValue", "label"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "课程名称",
            prop: "courseTitle",
            "min-width": "190"
          }), _createVNode(_component_el_table_column, {
            label: "试卷名称",
            prop: "title",
            "min-width": "200"
          }), _createVNode(_component_el_table_column, {
            label: "及格分",
            prop: "passScore",
            width: "90"
          }), _createVNode(_component_el_table_column, {
            label: "题目数",
            prop: "totalQuestions",
            width: "90"
          }), _createVNode(_component_el_table_column, {
            label: "考试时长(分钟)",
            prop: "durationMinutes",
            width: "130"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
          background: "",
          layout: "total, prev, pager, next",
          total: total.value,
          "page-size": pageSize.value,
          "current-page": page.value,
          onCurrentChange: onPageChange
        }, null, 8, ["total", "page-size", "current-page"])])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};